import React from "react";
import { PublicHeader } from "../../components/public";
import { Footer } from "../../lib";
import ComponentCSS from "../../lib/jquery";

export default function PublicLayout(props) {
  const { component: Component, ...rest} = props;
  return (
    <>
    <ComponentCSS>
    <PublicHeader />
    <Component {...rest}/>
    <Footer isPublic={true}/>
    </ComponentCSS>
    </>
  )
}